'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselNavButton", {
    enumerable: true,
    get: function() {
        return CarouselNavButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselNavButton = require("./useCarouselNavButton");
const _renderCarouselNavButton = require("./renderCarouselNavButton");
const _useCarouselNavButtonStylesstyles = require("./useCarouselNavButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselNavButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselNavButton.useCarouselNavButton_unstable)(props, ref);
    (0, _useCarouselNavButtonStylesstyles.useCarouselNavButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselNavButtonStyles_unstable')(state);
    return (0, _renderCarouselNavButton.renderCarouselNavButton_unstable)(state);
});
CarouselNavButton.displayName = 'CarouselNavButton';
